// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

const initialUserRoleFilter = () => {
  const item = window.localStorage.getItem('filterUserRole')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialUserStatusFilter = () => {
  const item = window.localStorage.getItem('filterUserStatus')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialUserSupplierFilter = () => {
  const item = window.localStorage.getItem('filterUserSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityDocumentCodeFilter = () => {
  const item = window.localStorage.getItem('filterQualityDocumentCode')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityDocumentNameFilter = () => {
  const item = window.localStorage.getItem('filterQualityDocumentName')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityDocumentSupplierFilter = () => {
  const item = window.localStorage.getItem('filterQualityDocumentSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialPurchaseDocumentCodeFilter = () => {
  const item = window.localStorage.getItem('filterPurchaseDocumentCode')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialPurchaseDocumentNameFilter = () => {
  const item = window.localStorage.getItem('filterPurchaseDocumentName')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialPurchaseDocumentSupplierFilter = () => {
  const item = window.localStorage.getItem('filterPurchaseDocumentSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialInputQualityControlWaybillNumberFilter = () => {
  const item = window.localStorage.getItem('filterInputQualityControlWaybillNumber')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialInputQualityControlShipmentDateFilter = () => {
  const item = window.localStorage.getItem('filterInputQualityControlShipmentDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialInputQualityControlReceivedDateFilter = () => {
  const item = window.localStorage.getItem('filterInputQualityControlReceivedDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialInputQualityControlStatusFilter = () => {
  const item = window.localStorage.getItem('filterInputQualityControlStatus')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialInputQualityControlSupplierFilter = () => {
  const item = window.localStorage.getItem('filterInputQualityControlSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotificationErrorSourceFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotificationErrorSource')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotificationDetectionDateFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotificationDetectionDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotificationDeadlineDateFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotificationDeadlineDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotificationStatusFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotificationStatus')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotificationSupplierFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotificationSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotification8dErrorSourceFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotification8dErrorSource')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotification8dDetectionDateFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotification8dDetectionDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotification8dDeadlineDateFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotification8dDeadlineDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotification8dStatusFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotification8dStatus')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialErrorNotification8dSupplierFilter = () => {
  const item = window.localStorage.getItem('filterErrorNotification8dSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderOpenOrderNumberFilter = () => {
  const item = window.localStorage.getItem('filterOrderOpenOrderNumber')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderOpenCurrencyFilter = () => {
  const item = window.localStorage.getItem('filterOrderOpenCurrency')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderOpenOrderDateFilter = () => {
  const item = window.localStorage.getItem('filterOrderOpenOrderDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderOpenDeadlineDateFilter = () => {
  const item = window.localStorage.getItem('filterOrderOpenDeadlineDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderOpenDeliveryDateFilter = () => {
  const item = window.localStorage.getItem('filterOrderOpenDeliveryDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderOpenSupplierFilter = () => {
  const item = window.localStorage.getItem('filterOrderOpenSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderApprovalOrderNumberFilter = () => {
  const item = window.localStorage.getItem('filterOrderApprovalOrderNumber')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderApprovalCurrencyFilter = () => {
  const item = window.localStorage.getItem('filterOrderApprovalCurrency')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderApprovalOrderDateFilter = () => {
  const item = window.localStorage.getItem('filterOrderApprovalOrderDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderApprovalDeadlineDateFilter = () => {
  const item = window.localStorage.getItem('filterOrderApprovalDeadlineDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderApprovalDeliveryDateFilter = () => {
  const item = window.localStorage.getItem('filterOrderApprovalDeliveryDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialOrderApprovalSupplierFilter = () => {
  const item = window.localStorage.getItem('filterOrderApprovalSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAdvanceShipNoticeWaybillNumberFilter = () => {
  const item = window.localStorage.getItem('filterAdvanceShipNoticeWaybillNumber')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAdvanceShipNoticeShipmentDateFilter = () => {
  const item = window.localStorage.getItem('filterAdvanceShipNoticeShipmentDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAdvanceShipNoticeDeliveryDateFilter = () => {
  const item = window.localStorage.getItem('filterAdvanceShipNoticeDeliveryDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAdvanceShipNoticeStatusFilter = () => {
  const item = window.localStorage.getItem('filterAdvanceShipNoticeStatus')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAdvanceShipNoticeSupplierFilter = () => {
  const item = window.localStorage.getItem('filterAdvanceShipNoticeSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialDeliveryReceiptWaybillNumberFilter = () => {
  const item = window.localStorage.getItem('filterDeliveryReceiptWaybillNumber')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialDeliveryReceiptShipmentDateFilter = () => {
  const item = window.localStorage.getItem('filterDeliveryReceiptShipmentDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialDeliveryReceiptDeliveryDateFilter = () => {
  const item = window.localStorage.getItem('filterDeliveryReceiptDeliveryDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialDeliveryReceiptStatusFilter = () => {
  const item = window.localStorage.getItem('filterDeliveryReceiptStatus')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialDeliveryReceiptSupplierFilter = () => {
  const item = window.localStorage.getItem('filterDeliveryReceiptSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityReportMonthFilter = () => {
  const item = window.localStorage.getItem('filterQualityReportMonth')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityReportStartDateFilter = () => {
  const item = window.localStorage.getItem('filterQualityReportStartDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityReportEndDateFilter = () => {
  const item = window.localStorage.getItem('filterQualityReportEndDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialQualityReportSupplierFilter = () => {
  const item = window.localStorage.getItem('filterQualityReportSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAnalyticMonthFilter = () => {
  const item = window.localStorage.getItem('filterAnalyticMonth')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAnalyticStartDateFilter = () => {
  const item = window.localStorage.getItem('filterAnalyticStartDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAnalyticEndDateFilter = () => {
  const item = window.localStorage.getItem('filterAnalyticEndDate')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAnalyticSupplierFilter = () => {
  const item = window.localStorage.getItem('filterAnalyticSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialAnalyticSupplierTypeFilter = () => {
  const item = window.localStorage.getItem('filterAnalyticSupplierType')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialPurchaseProductPriceCodeFilter = () => {
  const item = window.localStorage.getItem('filterPurchaseProductPriceCode')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialPurchaseProductPriceNameFilter = () => {
  const item = window.localStorage.getItem('filterPurchaseProductPriceName')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const initialPurchaseProductPriceSupplierFilter = () => {
  const item = window.localStorage.getItem('filterPurchaseProductPriceSupplier')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}

export const listFilterSlice = createSlice({
  name: 'list-filter',
  initialState: {
    userRoleFilter: initialUserRoleFilter(),
    userStatusFilter: initialUserStatusFilter(),
    userSupplierFilter: initialUserSupplierFilter(),
    qualityDocumentCodeFilter: initialQualityDocumentCodeFilter(),
    qualityDocumentNameFilter: initialQualityDocumentNameFilter(),
    qualityDocumentSupplierFilter: initialQualityDocumentSupplierFilter(),
    purchaseDocumentCodeFilter: initialPurchaseDocumentCodeFilter(),
    purchaseDocumentNameFilter: initialPurchaseDocumentNameFilter(),
    purchaseDocumentSupplierFilter: initialPurchaseDocumentSupplierFilter(),
    inputQualityControlWaybillNumberFilter: initialInputQualityControlWaybillNumberFilter(),
    inputQualityControlShipmentDateFilter: initialInputQualityControlShipmentDateFilter(),
    inputQualityControlReceivedDateFilter: initialInputQualityControlReceivedDateFilter(),
    inputQualityControlStatusFilter: initialInputQualityControlStatusFilter(),
    inputQualityControlSupplierFilter: initialInputQualityControlSupplierFilter(),
    errorNotificationErrorSourceFilter: initialErrorNotificationErrorSourceFilter(),
    errorNotificationDetectionDateFilter: initialErrorNotificationDetectionDateFilter(),
    errorNotificationDeadlineDateFilter: initialErrorNotificationDeadlineDateFilter(),
    errorNotificationStatusFilter: initialErrorNotificationStatusFilter(),
    errorNotificationSupplierFilter: initialErrorNotificationSupplierFilter(),
    errorNotification8dErrorSourceFilter: initialErrorNotification8dErrorSourceFilter(),
    errorNotification8dDetectionDateFilter: initialErrorNotification8dDetectionDateFilter(),
    errorNotification8dDeadlineDateFilter: initialErrorNotification8dDeadlineDateFilter(),
    errorNotification8dStatusFilter: initialErrorNotification8dStatusFilter(),
    errorNotification8dSupplierFilter: initialErrorNotification8dSupplierFilter(),
    orderOpenOrderNumberFilter: initialOrderOpenOrderNumberFilter(),
    orderOpenCurrencyFilter: initialOrderOpenCurrencyFilter(),
    orderOpenOrderDateFilter: initialOrderOpenOrderDateFilter(),
    orderOpenDeadlineDateFilter: initialOrderOpenDeadlineDateFilter(),
    orderOpenDeliveryDateFilter: initialOrderOpenDeliveryDateFilter(),
    orderOpenSupplierFilter: initialOrderOpenSupplierFilter(),
    orderApprovalOrderNumberFilter: initialOrderApprovalOrderNumberFilter(),
    orderApprovalCurrencyFilter: initialOrderApprovalCurrencyFilter(),
    orderApprovalOrderDateFilter: initialOrderApprovalOrderDateFilter(),
    orderApprovalDeadlineDateFilter: initialOrderApprovalDeadlineDateFilter(),
    orderApprovalDeliveryDateFilter: initialOrderApprovalDeliveryDateFilter(),
    orderApprovalSupplierFilter: initialOrderApprovalSupplierFilter(),
    advanceShipNoticeWaybillNumberFilter: initialAdvanceShipNoticeWaybillNumberFilter(),
    advanceShipNoticeShipmentDateFilter: initialAdvanceShipNoticeShipmentDateFilter(),
    advanceShipNoticeDeliveryDateFilter: initialAdvanceShipNoticeDeliveryDateFilter(),
    advanceShipNoticeStatusFilter: initialAdvanceShipNoticeStatusFilter(),
    advanceShipNoticeSupplierFilter: initialAdvanceShipNoticeSupplierFilter(),
    deliveryReceiptWaybillNumberFilter: initialDeliveryReceiptWaybillNumberFilter(),
    deliveryReceiptShipmentDateFilter: initialDeliveryReceiptShipmentDateFilter(),
    deliveryReceiptDeliveryDateFilter: initialDeliveryReceiptDeliveryDateFilter(),
    deliveryReceiptStatusFilter: initialDeliveryReceiptStatusFilter(),
    deliveryReceiptSupplierFilter: initialDeliveryReceiptSupplierFilter(),
    qualityReportMonthFilter: initialQualityReportMonthFilter(),
    qualityReportStartDateFilter: initialQualityReportStartDateFilter(),
    qualityReportEndDateFilter: initialQualityReportEndDateFilter(),
    qualityReportSupplierFilter: initialQualityReportSupplierFilter(),
    analyticMonthFilter: initialAnalyticMonthFilter(),
    analyticStartDateFilter: initialAnalyticStartDateFilter(),
    analyticEndDateFilter: initialAnalyticEndDateFilter(),
    analyticSupplierFilter: initialAnalyticSupplierFilter(),
    analyticSupplierTypeFilter: initialAnalyticSupplierTypeFilter(),
    purchaseProductPriceCodeFilter: initialPurchaseProductPriceCodeFilter(),
    purchaseProductPriceNameFilter: initialPurchaseProductPriceNameFilter(),
    purchaseProductPriceSupplierFilter: initialPurchaseProductPriceSupplierFilter()
  },
  reducers: {
    handleUserRoleFilter: (state, action) => {
      state.userRoleFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterUserRole', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterUserRole')
    },
    handleUserStatusFilter: (state, action) => {
      state.userStatusFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterUserStatus', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterUserStatus')
    },
    handleUserSupplierFilter: (state, action) => {
      state.userSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterUserSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterUserSupplier')
    },
    handleQualityDocumentCodeFilter: (state, action) => {
      state.qualityDocumentCodeFilter = action.payload
      action.payload !== null && action.payload !== '' && action.payload !== undefined ? window.localStorage.setItem('filterQualityDocumentCode', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityDocumentCode')
    },
    handleQualityDocumentNameFilter: (state, action) => {
      state.qualityDocumentNameFilter = action.payload
      action.payload !== null && action.payload !== '' && action.payload !== undefined ? window.localStorage.setItem('filterQualityDocumentName', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityDocumentName')
    },
    handleQualityDocumentSupplierFilter: (state, action) => {
      state.qualityDocumentSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterQualityDocumentSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityDocumentSupplier')
    },
    handlePurchaseDocumentCodeFilter: (state, action) => {
      state.purchaseDocumentCodeFilter = action.payload
      action.payload !== null && action.payload !== '' && action.payload !== undefined ? window.localStorage.setItem('filterPurchaseDocumentCode', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterPurchaseDocumentCode')
    },
    handlePurchaseDocumentNameFilter: (state, action) => {
      state.purchaseDocumentNameFilter = action.payload
      action.payload !== null && action.payload !== '' && action.payload !== undefined ? window.localStorage.setItem('filterPurchaseDocumentName', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterPurchaseDocumentName')
    },
    handlePurchaseDocumentSupplierFilter: (state, action) => {
      state.purchaseDocumentSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterPurchaseDocumentSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterPurchaseDocumentSupplier')
    },
    handleInputQualityControlWaybillNumberFilter: (state, action) => {
      state.inputQualityControlWaybillNumberFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterInputQualityControlWaybillNumber', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterInputQualityControlWaybillNumber')
    },
    handleInputQualityControlShipmentDateFilter: (state, action) => {
      state.inputQualityControlShipmentDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterInputQualityControlShipmentDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterInputQualityControlShipmentDate')
    },
    handleInputQualityControlReceivedDateFilter: (state, action) => {
      state.inputQualityControlReceivedDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterInputQualityControlReceivedDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterInputQualityControlReceivedDate')
    },
    handleInputQualityControlStatusFilter: (state, action) => {
      state.inputQualityControlStatusFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterInputQualityControlStatus', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterInputQualityControlStatus')
    },
    handleInputQualityControlSupplierFilter: (state, action) => {
      state.inputQualityControlSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterInputQualityControlSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterInputQualityControlSupplier')
    },
    handleErrorNotificationErrorSourceFilter: (state, action) => {
      state.errorNotificationErrorSourceFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotificationErrorSource', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotificationErrorSource')
    },
    handleErrorNotificationDetectionDateFilter: (state, action) => {
      state.errorNotificationDetectionDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotificationDetectionDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotificationDetectionDate')
    },
    handleErrorNotificationDeadlineDateFilter: (state, action) => {
      state.errorNotificationDeadlineDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotificationDeadlineDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotificationDeadlineDate')
    },
    handleErrorNotificationStatusFilter: (state, action) => {
      state.errorNotificationStatusFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotificationStatus', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotificationStatus')
    },
    handleErrorNotificationSupplierFilter: (state, action) => {
      state.errorNotificationSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotificationSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotificationSupplier')
    },
    handleErrorNotification8dErrorSourceFilter: (state, action) => {
      state.errorNotification8dErrorSourceFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotification8dErrorSource', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotification8dErrorSource')
    },
    handleErrorNotification8dDetectionDateFilter: (state, action) => {
      state.errorNotification8dDetectionDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotification8dDetectionDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotification8dDetectionDate')
    },
    handleErrorNotification8dDeadlineDateFilter: (state, action) => {
      state.errorNotification8dDeadlineDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotification8dDeadlineDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotification8dDeadlineDate')
    },
    handleErrorNotification8dStatusFilter: (state, action) => {
      state.errorNotification8dStatusFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotification8dStatus', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotification8dStatus')
    },
    handleErrorNotification8dSupplierFilter: (state, action) => {
      state.errorNotification8dSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterErrorNotification8dSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterErrorNotification8dSupplier')
    },
    handleOrderOpenOrderNumberFilter: (state, action) => {
      state.orderOpenOrderNumberFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderOpenOrderNumber', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderOpenOrderNumber')
    },
    handleOrderOpenCurrencyFilter : (state, action) => {
      state.orderOpenCurrencyFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderOpenCurrency', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderOpenCurrency')
    },
    handleOrderOpenOrderDateFilter : (state, action) => {
      state.orderOpenOrderDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderOpenOrderDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderOpenOrderDate')
    },
    handleOrderOpenDeadlineDateFilter : (state, action) => {
      state.orderOpenDeadlineDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderOpenDeadlineDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderOpenDeadlineDate')
    },
    handleOrderOpenDeliveryDateFilter : (state, action) => {
      state.orderOpenDeliveryDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderOpenDeliveryDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderOpenDeliveryDate')
    },
    handleOrderOpenSupplierFilter : (state, action) => {
      state.orderOpenSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderOpenSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderOpenSupplier')
    },
    handleOrderApprovalOrderNumberFilter : (state, action) => {
      state.orderApprovalOrderNumberFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderApprovalOrderNumber', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderApprovalOrderNumber')
    },
    handleOrderApprovalCurrencyFilter : (state, action) => {
      state.orderApprovalCurrencyFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderApprovalCurrency', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderApprovalCurrency')
    },
    handleOrderApprovalOrderDateFilter : (state, action) => {
      state.orderApprovalOrderDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderApprovalOrderDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderApprovalOrderDate')
    },
    handleOrderApprovalDeadlineDateFilter : (state, action) => {
      state.orderApprovalDeadlineDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderApprovalDeadlineDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderApprovalDeadlineDate')
    },
    handleOrderApprovalDeliveryDateFilter : (state, action) => {
      state.orderApprovalDeliveryDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderApprovalDeliveryDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderApprovalDeliveryDate')
    },
    handleOrderApprovalSupplierFilter : (state, action) => {
      state.orderApprovalSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterOrderApprovalSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterOrderApprovalSupplier')
    },
    handleAdvanceShipNoticeWaybillNumberFilter : (state, action) => {
      state.advanceShipNoticeWaybillNumberFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAdvanceShipNoticeWaybillNumber', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAdvanceShipNoticeWaybillNumber')
    },
    handleAdvanceShipNoticeShipmentDateFilter : (state, action) => {
      state.advanceShipNoticeShipmentDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAdvanceShipNoticeShipmentDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAdvanceShipNoticeShipmentDate')
    },
    handleAdvanceShipNoticeDeliveryDateFilter : (state, action) => {
      state.advanceShipNoticeDeliveryDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAdvanceShipNoticeDeliveryDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAdvanceShipNoticeDeliveryDate')
    },
    handleAdvanceShipNoticeStatusFilter : (state, action) => {
      state.advanceShipNoticeStatusFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAdvanceShipNoticeStatus', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAdvanceShipNoticeStatus')
    },
    handleAdvanceShipNoticeSupplierFilter : (state, action) => {
      state.advanceShipNoticeSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAdvanceShipNoticeSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAdvanceShipNoticeSupplier')
    },
    handleDeliveryReceiptWaybillNumberFilter : (state, action) => {
      state.deliveryReceiptWaybillNumberFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterDeliveryReceiptWaybillNumber', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterDeliveryReceiptWaybillNumber')
    },
    handleDeliveryReceiptShipmentDateFilter : (state, action) => {
      state.deliveryReceiptShipmentDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterDeliveryReceiptShipmentDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterDeliveryReceiptShipmentDate')
    },
    handleDeliveryReceiptDeliveryDateFilter : (state, action) => {
      state.deliveryReceiptDeliveryDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterDeliveryReceiptDeliveryDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterDeliveryReceiptDeliveryDate')
    },
    handleDeliveryReceiptStatusFilter : (state, action) => {
      state.deliveryReceiptStatusFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterDeliveryReceiptStatus', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterDeliveryReceiptStatus')
    },
    handleDeliveryReceiptSupplierFilter : (state, action) => {
      state.deliveryReceiptSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterDeliveryReceiptSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterDeliveryReceiptSupplier')
    },
    handleQualityReportMonthFilter : (state, action) => {
      state.qualityReportMonthFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterQualityReportMonth', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityReportMonth')
    },
    handleQualityReportStartDateFilter : (state, action) => {
      state.qualityReportStartDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterQualityReportStartDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityReportStartDate')
    },
    handleQualityReportEndDateFilter : (state, action) => {
      state.qualityReportEndDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterQualityReportEndDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityReportEndDate')
    },
    handleQualityReportSupplierFilter : (state, action) => {
      state.qualityReportSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterQualityReportSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterQualityReportSupplier')
    },
    handleAnalyticMonthFilter : (state, action) => {
      state.analyticMonthFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAnalyticMonth', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAnalyticMonth')
    },
    handleAnalyticStartDateFilter : (state, action) => {
      state.analyticStartDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAnalyticStartDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAnalyticStartDate')
    },
    handleAnalyticEndDateFilter : (state, action) => {
      state.analyticEndDateFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAnalyticEndDate', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAnalyticEndDate')
    },
    handleAnalyticSupplierFilter : (state, action) => {
      state.analyticSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAnalyticSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAnalyticSupplier')
    },
    handleAnalyticSupplierTypeFilter : (state, action) => {
      state.analyticSupplierTypeFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterAnalyticSupplierType', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterAnalyticSupplierType')
    },
    handlePurchaseProductPriceCodeFilter : (state, action) => {
      state.purchaseProductPriceCodeFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterPurchaseProductPriceCode', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterPurchaseProductPriceCode')
    },
    handlePurchaseProductPriceNameFilter : (state, action) => {
      state.purchaseProductPriceNameFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterPurchaseProductPriceName', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterPurchaseProductPriceName')
    },
    handlePurchaseProductPriceSupplierFilter : (state, action) => {
      state.purchaseProductPriceSupplierFilter = action.payload
      action.payload !== null && action.payload !== undefined ? window.localStorage.setItem('filterPurchaseProductPriceSupplier', JSON.stringify(action.payload)) : window.localStorage.removeItem('filterPurchaseProductPriceSupplier')
    }
 }
})

export const {
  handleUserRoleFilter,
  handleUserStatusFilter,
  handleUserSupplierFilter,
  handleQualityDocumentCodeFilter,
  handleQualityDocumentNameFilter,
  handleQualityDocumentSupplierFilter,
  handlePurchaseDocumentCodeFilter,
  handlePurchaseDocumentNameFilter,
  handlePurchaseDocumentSupplierFilter,
  handleInputQualityControlWaybillNumberFilter,
  handleInputQualityControlShipmentDateFilter,
  handleInputQualityControlReceivedDateFilter,
  handleInputQualityControlStatusFilter,
  handleInputQualityControlSupplierFilter,
  handleErrorNotificationErrorSourceFilter,
  handleErrorNotificationDetectionDateFilter,
  handleErrorNotificationDeadlineDateFilter,
  handleErrorNotificationStatusFilter,
  handleErrorNotificationSupplierFilter,
  handleErrorNotification8dErrorSourceFilter,
  handleErrorNotification8dDetectionDateFilter,
  handleErrorNotification8dDeadlineDateFilter,
  handleErrorNotification8dStatusFilter,
  handleErrorNotification8dSupplierFilter,
  handleOrderOpenOrderNumberFilter,
  handleOrderOpenCurrencyFilter,
  handleOrderOpenOrderDateFilter,
  handleOrderOpenDeadlineDateFilter,
  handleOrderOpenDeliveryDateFilter,
  handleOrderOpenSupplierFilter,
  handleOrderApprovalOrderNumberFilter,
  handleOrderApprovalCurrencyFilter,
  handleOrderApprovalOrderDateFilter,
  handleOrderApprovalDeadlineDateFilter,
  handleOrderApprovalDeliveryDateFilter,
  handleOrderApprovalSupplierFilter,
  handleAdvanceShipNoticeWaybillNumberFilter,
  handleAdvanceShipNoticeShipmentDateFilter,
  handleAdvanceShipNoticeDeliveryDateFilter,
  handleAdvanceShipNoticeStatusFilter,
  handleAdvanceShipNoticeSupplierFilter,
  handleDeliveryReceiptWaybillNumberFilter,
  handleDeliveryReceiptShipmentDateFilter,
  handleDeliveryReceiptDeliveryDateFilter,
  handleDeliveryReceiptStatusFilter,
  handleDeliveryReceiptSupplierFilter,
  handleQualityReportMonthFilter,
  handleQualityReportStartDateFilter,
  handleQualityReportEndDateFilter,
  handleQualityReportSupplierFilter,
  handleAnalyticMonthFilter,
  handleAnalyticStartDateFilter,
  handleAnalyticEndDateFilter,
  handleAnalyticSupplierFilter,
  handleAnalyticSupplierTypeFilter,
  handlePurchaseProductPriceCodeFilter,
  handlePurchaseProductPriceNameFilter,
  handlePurchaseProductPriceSupplierFilter
} = listFilterSlice.actions

export default listFilterSlice.reducer
